import { render, staticRenderFns } from "./ReportsList.vue?vue&type=template&id=28e6d2a6&scoped=true"
import script from "./ReportsList.vue?vue&type=script&lang=js"
export * from "./ReportsList.vue?vue&type=script&lang=js"
import style0 from "./ReportsList.vue?vue&type=style&index=0&id=28e6d2a6&prod&scoped=true&lang=scss"
import style1 from "./ReportsList.vue?vue&type=style&index=1&id=28e6d2a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e6d2a6",
  null
  
)

export default component.exports